export default function useRadioGroup({ props, emit }) {
  const change = (code) => {
    emit('input', code)
  }

  // 初始化
  const init = () => {
    if (!props.value) {
      for (const source of props.sources) {
        if (source.default) {
          change(source.code)
          break
        }
      }
      return
    }
  }

  return { init, change }
}
